import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import StaffListTable from 'components/organismos/master/general/staff/StaffListTable';
import BlockUI from 'components/molecules/BlockUi';
import { useStaffList } from './hooks';

const StaffsPage: React.FC = () => {
  const {
    staffList,
    fetchData,
    executiveId,
    setExecutiveId,
    employmentId,
    setEmploymentId,
    orgCode,
    setOrgCode,
    stateStatus,
    setStateStatus,
    blocking,
  } = useStaffList();

  return (
    <SidebarTemplate>
      <BlockUI blocking={blocking}>
        <StaffListTable
          staffList={staffList}
          fetchData={fetchData}
          executiveId={executiveId}
          setExecutiveId={setExecutiveId}
          employmentId={employmentId}
          setEmploymentId={setEmploymentId}
          orgCode={orgCode}
          setOrgCode={setOrgCode}
          stateStatus={stateStatus}
          setStateStatus={setStateStatus}
        />
      </BlockUI>
    </SidebarTemplate>
  );
};

export default StaffsPage;
